import { render, staticRenderFns } from "./Gamification.vue?vue&type=template&id=a4c09b0c&scoped=true&"
import script from "./Gamification.vue?vue&type=script&lang=js&"
export * from "./Gamification.vue?vue&type=script&lang=js&"
import style0 from "./Gamification.vue?vue&type=style&index=0&id=a4c09b0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c09b0c",
  null
  
)

export default component.exports